import { render, staticRenderFns } from "./contactIndex.vue?vue&type=template&id=786ff774&scoped=true&"
import script from "./contactIndex.vue?vue&type=script&lang=js&"
export * from "./contactIndex.vue?vue&type=script&lang=js&"
import style0 from "./css/index.css?vue&type=style&index=0&id=786ff774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786ff774",
  null
  
)

export default component.exports